"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverviewCalendarRow = exports.OverviewCalendarRowTitle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const lodash_1 = require("lodash");
const constants_1 = require("../../../constants");
const elements_1 = require("../../../elements");
exports.OverviewCalendarRowTitle = (0, styled_1.default)(elements_1.Clickable)({
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    padding: `${constants_1.theme.spacing[1]}px ${constants_1.theme.spacing[2]}px`,
    borderRadius: constants_1.theme.border.radius.small,
    ':hover': {
        backgroundColor: constants_1.Color.LIGHT_GREY,
    },
});
const Row = (0, styled_1.default)(elements_1.Flex)(({ isNested }) => ({
    gap: constants_1.theme.spacing[3],
    padding: `${constants_1.theme.spacing[1]}px ${constants_1.theme.spacing[1.5]}px`,
    alignItems: 'center',
    alignContent: 'center',
    borderBottom: `1px solid ${constants_1.Color.MEDIUM_GREY}`,
    background: isNested ? constants_1.Color.BACKGROUND_GREY : constants_1.Color.WHITE,
    ':last-child': {
        borderBottom: 'none',
    },
}));
const WeekCell = (0, styled_1.default)(elements_1.Flex)(({ background, color }) => ({
    background,
    color,
    borderRadius: constants_1.theme.border.radius.small,
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: constants_1.theme.font.weight.bold,
    userSelect: 'none',
}));
const OverviewCalendarRow = (props) => {
    const isBooking = props.type === 'BOOKING';
    return ((0, jsx_runtime_1.jsxs)(Row, { isNested: !!props.isNested, children: [props.title, (0, jsx_runtime_1.jsx)(elements_1.Div, { styles: {
                    display: 'grid',
                    gridTemplateColumns: `repeat(${props.weeks.length}, 80px)`,
                    gridTemplateRows: '34px',
                    gridGap: constants_1.theme.spacing[2],
                    height: '100%',
                    ml: 'auto',
                }, children: props.weeks.map((content, index) => {
                    if (props.type === 'HEADER') {
                        return ((0, jsx_runtime_1.jsxs)(WeekCell, { background: constants_1.Color.TRANSPARENT, color: constants_1.Color.DARK_GREY, children: ["v.", content] }, index));
                    }
                    if (content === null) {
                        return (0, jsx_runtime_1.jsx)(WeekCell, { background: constants_1.Color.TRANSPARENT }, index);
                    }
                    if (!content) {
                        return ((0, jsx_runtime_1.jsx)(WeekCell, { background: isBooking ? constants_1.Color.LIGHTER_GREEN : constants_1.Color.LIGHT_GREY, color: isBooking ? constants_1.Color.LIGHT_GREEN : constants_1.Color.LIGHTER_BLUE, children: "0" }, index));
                    }
                    return ((0, jsx_runtime_1.jsx)(WeekCell, { background: isBooking ? constants_1.Color.GREEN : constants_1.Color.LIGHTEST_BLUE, color: isBooking ? constants_1.Color.WHITE : constants_1.Color.DARK_BLUE, children: (0, jsx_runtime_1.jsx)(elements_1.Text, { fontSize: constants_1.theme.font.size[6], children: typeof content === 'number' ? (0, lodash_1.round)(content) : content }) }, index));
                }) })] }));
};
exports.OverviewCalendarRow = OverviewCalendarRow;
